import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/desktop/2_blue/2_blue"
 * Contains 1 texture(s)
 */
export class Desktop2BlueAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/desktop/2_blue/2_blue';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '2_blue.png'
    ] as const;
}
